import { jsx as s } from "react/jsx-runtime";
import { useState as e, useEffect as v } from "react";
import { I as x } from "./ic_arrowless_fill-EoSHNXJu.mjs";
import { t as y } from "./throttle-CbOTDqvg.mjs";
import { c as E } from "./tw-cn-mXgPecoF.mjs";
import { F } from "./floating-button-BY52IkIA.mjs";
const T = ({
  top: i = 150,
  scrollBehavior: m = "smooth",
  type: r = "translate",
  targetRef: o,
  onClick: l,
  className: a,
  hasGnb: d = !1,
  style: p
}) => {
  const [u, w] = e(!1);
  v(() => {
    const t = (o == null ? void 0 : o.current) || window, n = y(() => {
      var c;
      const h = ((c = o == null ? void 0 : o.current) == null ? void 0 : c.scrollTop) ?? window.scrollY;
      w(h > i);
    }, 100);
    return n(), t.addEventListener("scroll", n), () => {
      t.removeEventListener("scroll", n);
    };
  }, [i, o == null ? void 0 : o.current]);
  const b = () => {
    ((o == null ? void 0 : o.current) || window).scrollTo({ top: 0, behavior: m }), l == null || l();
  };
  return /* @__PURE__ */ s(
    "div",
    {
      className: E(
        "fixed left-1/2 w-full max-w-mobile-size -translate-x-1/2 transition-all duration-300 z-middle pc:bottom-24 pc:max-w-[none]",
        u ? `${r === "translate" && "translate-y-0"} opacity-100` : `${r === "translate" && "translate-y-100"} opacity-0`,
        d ? "bottom-80" : "bottom-16",
        a
      ),
      style: p,
      children: /* @__PURE__ */ s("div", { className: "absolute bottom-0 right-16 pc:right-24", children: /* @__PURE__ */ s(F, { icon: /* @__PURE__ */ s(x, {}), onClick: b }) })
    }
  );
};
export {
  T as G
};
